import { create } from 'zustand';

type View = 'List' | 'Grid';

interface PresentationUIState {
  // View / layout
  view: View;
  // Auto-focus suppression (arrow-key navigation)
  disableAutoFocus: boolean;
  // AI generation modal
  showGenerateWithAIModal: boolean;
  // Loading state while fetching templates
  isLoadingTemplates: boolean;

  // Actions
  toggleView: (view?: View) => void;
  setDisableAutoFocus: (value: boolean) => void;
  setShowGenerateWithAIModal: (show: boolean) => void;
  setIsLoadingTemplates: (loading: boolean) => void;
}

export const usePresentationUIStore = create<PresentationUIState>()((set) => ({
  view: 'List',
  disableAutoFocus: false,
  showGenerateWithAIModal: false,
  isLoadingTemplates: false,

  toggleView: (view) =>
    set((s) => ({ view: view ?? (s.view === 'List' ? 'Grid' : 'List') })),

  setDisableAutoFocus: (disableAutoFocus) => set({ disableAutoFocus }),
  setShowGenerateWithAIModal: (showGenerateWithAIModal) =>
    set({ showGenerateWithAIModal }),
  setIsLoadingTemplates: (isLoadingTemplates) => set({ isLoadingTemplates }),
}));

export type { PresentationUIState };
